export default "__VITE_ASSET__Ll3oahS3__"